import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { BACKEND } from "../config/configEnvs";
import { FaWpforms, FaChevronRight } from "react-icons/fa"


const EncuestasRespuestasDetails = () => {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const getFormsDetails = async () => {
    try {
      const response = await axios.get(
        `${BACKEND}/api/formularioServicioRespuestas/${id}?depth=3`
      );
      setData(response.data);
    } catch (error) {}
  };

  useEffect(() => {
    getFormsDetails();
  }, []);

  console.log(data)

  if (data) {
    if (!data.formulario?.servicio)
      return <div>Este formulario ha sido eliminado por el administrador</div>;
  }

  if (!data) return;

  return (
    <div className="flex flex-col h-screen w-full">

      {/* Barra superior */}
      <div className="flex flex-row px-4 py-2 bg-gray-100 shadow-sm"> 
        <div className="flex flex-row w-full items-center gap-4 justify-between">
          <div className="flex items-center gap-4 py-4">
            <FaWpforms className="text-zinc-700 text-2xl" />
            <h2 className="text-2xl font-bold text-zinc-700">
              Formulario de entrada
            </h2>
            <FaChevronRight className="text-orange-500" />
            <h2 className="text-2xl font-bold text-zinc-700">
              {data?.servicioCotizacion?.cotizacion?.cliente?.nombreComercial}
            </h2>
            <FaChevronRight className="text-orange-500" />
            <h2 className="text-2xl font-bold text-zinc-700">
              {data?.servicioCotizacion?.servicio?.name}
            </h2>
          </div>
        </div>
      </div>

      {/* Contenido */}
      <div className="mx-auto w-full px-4 py-6 overflow-y-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {data?.respuestas && data?.respuestas.length > 0 ? (
            data.respuestas.map((e, index) => (
              <div
                key={e.id}
                className="bg-white border border-gray-200 rounded-xl shadow-sm p-4 transition hover:shadow-md"
              >
                <h3 className="text-sm font-semibold text-blue-800 mb-2">
                  {index + 1}. {e.pregunta.pregunta}
                </h3>

                <p className="text-sm text-gray-700 mb-3 break-words">{e.respuesta}</p>

                {e.media && (
                  <div className="flex flex-col gap-2">
                    {e.media.mimeType.startsWith("image/") && (
                      <a
                        href={e.media.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex justify-start"
                      >
                        <img
                          src={e.media.url}
                          alt="uploaded"
                          className="rounded-md max-h-40 object-contain"
                        />
                      </a>
                    )}
                    <a
                      href={e.media.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-xs text-blue-600 hover:underline break-words"
                    >
                      {e.media.filename}
                    </a>
                  </div>
                )}
              </div>
            ))
          ) : (
            <div className="col-span-full text-center text-gray-500 py-10">
              No hay respuestas disponibles.
            </div>
          )}
        </div>
      </div>
    </div>


  );
};

export default EncuestasRespuestasDetails;



// {data.formulario.tipo !== "entrada" && (
//   <div className=" max-w-2xl mx-auto flex flex-col gap-4 sm:grid sm:grid-cols-2 ">
//     <div className=" bg-green-700  bg-opacity-10 text-green-600 p-2 rounded-lg">
//       <p className=" text-xs font-bold text-center">
//         Puntaje Especialista
//       </p>
//       {data?.puntajeComercial && (
//         <p className=" font-bold text-lg text-center pt-2">
//           {data?.puntajeComercial}
//         </p>
//       )}
//     </div>

//     <div className=" bg-green-700  bg-opacity-10 text-green-600 p-2 rounded-lg">
//       <p className=" text-xs font-bold text-center">Puntaje Comercial</p>
//       {data?.puntajeEspecialista && (
//         <p className=" font-bold text-lg text-center pt-2">
//           {data?.puntajeEspecialista}
//         </p>
//       )}
//     </div>
//   </div>
// )}
